import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { SiteContentProvider } from './content/SiteContentContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SiteContentProvider>
    <App />
  </SiteContentProvider>
);
